import { render, staticRenderFns } from "./ChangeEmail.vue?vue&type=template&id=2230ead0"
import script from "./ChangeEmail.vue?vue&type=script&lang=js"
export * from "./ChangeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports